import { Logging } from '#common/logging';
import { withStats } from '#common/stats';
import { KeyRangeLockingProxy } from './proxy/key-range-locking-proxy';
import { KeyRangeLockingStats } from './types';
export const createKeyRangeLockingClient = (fsId, client, serverSession) => {
    return new KeyRangeLockingClientImpl(fsId, client, serverSession);
};
class KeyRangeLockingClientImpl {
    log = Logging.getLogger('KeyRangeLockingClient');
    statistics = new KeyRangeLockingStats(this.log);
    keyRangeLockingProxy;
    constructor(fsId, client, serverSession) {
        this.keyRangeLockingProxy = new KeyRangeLockingProxy(fsId, client, serverSession);
    }
    async lock(lockParams) {
        return await withStats(this.statistics.lock, () => {
            return this.keyRangeLockingProxy.lock(lockParams);
        });
    }
    async unlockAllLocksHeldByNode(nodeId) {
        return await withStats(this.statistics.unlockAllHeldByNode, () => {
            return this.keyRangeLockingProxy.unlockAllLocksHeldByNode(nodeId);
        }, { nodeId });
    }
    async unlockRanges(unlockRanges) {
        return await withStats(this.statistics.unlockRange, () => {
            return this.keyRangeLockingProxy.unlockRanges(unlockRanges);
        });
    }
    stats() {
        return this.statistics;
    }
}
